import UsageExplorer from './UsageExplorer';

const usage = {
    list: UsageExplorer,
};

export default usage;